// Каталог визуализаций: порядок, иконки, группы и выбор иконки KPI.

import { VISUALIZATION_LABELS as LOCALIZED_VISUALIZATION_LABELS } from '../i18n';
import type { VisualizationType } from '../types';

import { escapeHtml, icon } from './dom';

export const VISUALIZATION_ICONS: Record<VisualizationType, string> = {
  kpi: 'badge-percent',
  line: 'chart-line',
  bar: 'chart-bar',
  area: 'chart-area',
  normalized_bar: 'chart-no-axes-column-increasing',
  heatmap: 'grid-3x3',
  scatter: 'scatter-chart',
  pie: 'chart-pie',
  histogram: 'chart-column',
  population_pyramid: 'chart-bar-stacked',
  network: 'network',
  flow: 'workflow',
  flow_map: 'route',
  small_multiples_bar: 'panels-top-left',
  district_mini_maps: 'panel-top',
  table: 'table-2',
  choropleth: 'map',
  map_symbols: 'map-pin',
};

export const KPI_ICON_CHOICES = [
  { id: 'activity', label: 'Активность', labelEn: 'Activity' },
  { id: 'users', label: 'Население', labelEn: 'Population' },
  { id: 'baby', label: 'Рождаемость', labelEn: 'Fertility' },
  { id: 'heart-pulse', label: 'Здоровье', labelEn: 'Health' },
  { id: 'route', label: 'Миграция', labelEn: 'Migration' },
  { id: 'landmark', label: 'Экономика', labelEn: 'Economy' },
  { id: 'briefcase-business', label: 'Труд', labelEn: 'Labor' },
  { id: 'graduation-cap', label: 'Образование', labelEn: 'Education' },
  { id: 'home', label: 'Жильё', labelEn: 'Housing' },
  { id: 'building-2', label: 'Город', labelEn: 'City' },
  { id: 'factory', label: 'Промышленность', labelEn: 'Industry' },
  { id: 'wheat', label: 'Сельское хозяйство', labelEn: 'Agriculture' },
  { id: 'shopping-basket', label: 'Торговля', labelEn: 'Trade' },
  { id: 'bus', label: 'Транспорт', labelEn: 'Transport' },
  { id: 'trees', label: 'Среда', labelEn: 'Environment' },
  { id: 'shield-check', label: 'Качество', labelEn: 'Quality' },
] as const;

export function renderKpiIconChoices(): string {
  return KPI_ICON_CHOICES.map((choice) => `
    <button class="kpi-icon-choice" type="button" data-kpi-icon="${escapeHtml(choice.id)}" title="${escapeHtml(choice.label)}" aria-label="${escapeHtml(choice.label)}">
      ${icon(choice.id)}
      <span>${escapeHtml(choice.label)}</span>
    </button>
  `).join('');
}

export const VISUALIZATION_ORDER = Object.keys(LOCALIZED_VISUALIZATION_LABELS.ru) as VisualizationType[];

export const CARTESIAN_BASE_VISUALIZATIONS = new Set<VisualizationType>(['line', 'bar', 'area', 'normalized_bar', 'table']);

export const MAP_BASE_VISUALIZATIONS = new Set<VisualizationType>(['choropleth', 'map_symbols']);
